import * as actionTypes from './../constants/action-types';
import { updateObject } from './../../../../shared/utils';

const initialState = {
  calendarCategorySettings: null,
  calendarCategorySettingsError: null,
  calendarCategorySettingsLoading: false,

  calendarCategories: null,
  calendarCategoriesError: null,
  calendarCategoriesLoading: false,

  calendarEvents: null,
  calendarEventsError: null,
  calendarEventsLoading: false,

  saveEventResult: null,
  saveEventError: null,
  saveEventLoading: false,

  deleteEventResult: null,
  deleteEventError: null,
  deleteEventLoading: false,

  saveCategoryResult: null,
  saveCategoryError: null,
  saveCategoryLoading: false,

  deleteCategoryResult: null,
  deleteCategoryError: null,
  deleteCategoryLoading: false,

  saveCategorySettingResult: null,
  saveCategorySettingError: null,
  saveCategorySettingLoading: false,

  deleteCategorySettingResult: null,
  deleteCategorySettingError: null,
  deleteCategorySettingLoading: false,
};

//getCalendarCategorySettings
const getCalendarCategorySettingsStart = (state, action) => {
  return updateObject(state, {
    calendarCategorySettingsError: null,
    calendarCategorySettingsLoading: true,
  });
};

const getCalendarCategorySettingsSuccess = (state, action) => {
  return updateObject(state, {
    calendarCategorySettings: action.calendarCategorySettings,
    calendarCategorySettingsError: null,
    calendarCategorySettingsLoading: false,
  });
};

const getCalendarCategorySettingsFail = (state, action) => {
  return updateObject(state, {
    calendarCategorySettings: null,
    calendarCategorySettingsError: action.error,
    calendarCategorySettingsLoading: false,
  });
};

//getCalendarCategories
const getCalendarCategoriesStart = (state, action) => {
  return updateObject(state, {
    calendarCategoriesError: null,
    calendarCategoriesLoading: true,
  });
};

const getCalendarCategoriesSuccess = (state, action) => {
  return updateObject(state, {
    calendarCategories: action.calendarCategories,
    calendarCategoriesError: null,
    calendarCategoriesLoading: false,
  });
};

const getCalendarCategoriesFail = (state, action) => {
  return updateObject(state, {
    calendarCategories: null,
    calendarCategoriesError: action.error,
    calendarCategoriesLoading: false,
  });
};

//getCalendarEvents
const getCalendarEventsStart = (state, action) => {
  return updateObject(state, {
    calendarEventsError: null,
    calendarEventsLoading: true,
  });
};

const getCalendarEventsSuccess = (state, action) => {
  return updateObject(state, {
    calendarEvents: action.calendarEvents,
    calendarEventsError: null,
    calendarEventsLoading: false,
  });
};

const getCalendarEventsFail = (state, action) => {
  return updateObject(state, {
    calendarEvents: null,
    calendarEventsError: action.error,
    calendarEventsLoading: false,
  });
};

//SaveEvent
const saveEventStart = (state, action) => {
  return updateObject(state, {
    saveEventError: null,
    saveEventLoading: true,
  });
};

const saveEventSuccess = (state, action) => {
  return updateObject(state, {
    saveEventResult: action.saveEventResult,
    saveEventError: null,
    saveEventLoading: false,
  });
};

const saveEventFail = (state, action) => {
  return updateObject(state, {
    saveEventResult: null,
    saveEventError: action.error,
    saveEventLoading: false,
  });
};

//deleteEvent
const deleteEventStart = (state, action) => {
  return updateObject(state, {
    deleteEventError: null,
    deleteEventLoading: true,
  });
};

const deleteEventSuccess = (state, action) => {
  return updateObject(state, {
    deleteEventResult: action.deleteEventResult,
    deleteEventError: null,
    deleteEventLoading: false,
  });
};

const deleteEventFail = (state, action) => {
  return updateObject(state, {
    deleteEventResult: null,
    deleteEventError: action.error,
    deleteEventLoading: false,
  });
};

//saveCategory
const saveCategoryStart = (state, action) => {
  return updateObject(state, {
    saveCategoryError: null,
    saveCategoryLoading: true,
  });
};

const saveCategorySuccess = (state, action) => {
  return updateObject(state, {
    saveCategoryResult: action.saveCategoryResult,
    saveCategoryError: null,
    saveCategoryLoading: false,
  });
};

const saveCategoryFail = (state, action) => {
  return updateObject(state, {
    saveCategoryResult: null,
    saveCategoryError: action.error,
    saveCategoryLoading: false,
  });
};

//deleteCategory
const deleteCategoryStart = (state, action) => {
  return updateObject(state, {
    deleteCategoryError: null,
    deleteCategoryLoading: true,
  });
};

const deleteCategorySuccess = (state, action) => {
  return updateObject(state, {
    deleteCategoryResult: action.deleteCategoryResult,
    deleteCategoryError: null,
    deleteCategoryLoading: false,
  });
};

const deleteCategoryFail = (state, action) => {
  return updateObject(state, {
    deleteCategoryResult: null,
    deleteCategoryError: action.error,
    deleteCategoryLoading: false,
  });
};

//saveCategorySetting
const saveCategorySettingStart = (state, action) => {
  return updateObject(state, {
    saveCategorySettingError: null,
    saveCategorySettingLoading: true,
  });
};

const saveCategorySettingSuccess = (state, action) => {
  return updateObject(state, {
    saveCategorySettingResult: action.saveCategorySettingResult,
    saveCategorySettingError: null,
    saveCategorySettingLoading: false,
  });
};

const saveCategorySettingFail = (state, action) => {
  return updateObject(state, {
    saveCategorySettingResult: null,
    saveCategorySettingError: action.error,
    saveCategorySettingLoading: false,
  });
};

//deleteCategorySetting
const deleteCategorySettingStart = (state, action) => {
  return updateObject(state, {
    deleteCategorySettingError: null,
    deleteCategorySettingLoading: true,
  });
};

const deleteCategorySettingSuccess = (state, action) => {
  return updateObject(state, {
    deleteCategorySettingResult: action.deleteCategorySettingResult,
    deleteCategorySettingError: null,
    deleteCategorySettingLoading: false,
  });
};

const deleteCategorySettingFail = (state, action) => {
  return updateObject(state, {
    deleteCategorySettingResult: null,
    deleteCategorySettingError: action.error,
    deleteCategorySettingLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CALENDAR_GET_CATEGORY_SETTINGS_START:
      return getCalendarCategorySettingsStart(state, action);
    case actionTypes.CALENDAR_GET_CATEGORY_SETTINGS_SUCCESS:
      return getCalendarCategorySettingsSuccess(state, action);
    case actionTypes.CALENDAR_GET_CATEGORY_SETTINGS_FAIL:
      return getCalendarCategorySettingsFail(state, action);

    case actionTypes.CALENDAR_GET_CATEGORIES_START:
      return getCalendarCategoriesStart(state, action);
    case actionTypes.CALENDAR_GET_CATEGORIES_SUCCESS:
      return getCalendarCategoriesSuccess(state, action);
    case actionTypes.CALENDAR_GET_CATEGORIES_FAIL:
      return getCalendarCategoriesFail(state, action);

    case actionTypes.CALENDAR_GET_EVENTS_START:
      return getCalendarEventsStart(state, action);
    case actionTypes.CALENDAR_GET_EVENTS_SUCCESS:
      return getCalendarEventsSuccess(state, action);
    case actionTypes.CALENDAR_GET_EVENTS_FAIL:
      return getCalendarEventsFail(state, action);

    case actionTypes.CALENDAR_SAVE_EVENT_START:
      return saveEventStart(state, action);
    case actionTypes.CALENDAR_SAVE_EVENT_SUCCESS:
      return saveEventSuccess(state, action);
    case actionTypes.CALENDAR_SAVE_EVENT_FAIL:
      return saveEventFail(state, action);

    case actionTypes.CALENDAR_DELETE_EVENT_START:
      return deleteEventStart(state, action);
    case actionTypes.CALENDAR_DELETE_EVENT_SUCCESS:
      return deleteEventSuccess(state, action);
    case actionTypes.CALENDAR_DELETE_EVENT_FAIL:
      return deleteEventFail(state, action);

    case actionTypes.CALENDAR_SAVE_CATEGORY_START:
      return saveCategoryStart(state, action);
    case actionTypes.CALENDAR_SAVE_CATEGORY_SUCCESS:
      return saveCategorySuccess(state, action);
    case actionTypes.CALENDAR_SAVE_CATEGORY_FAIL:
      return saveCategoryFail(state, action);

    case actionTypes.CALENDAR_DELETE_CATEGORY_START:
      return deleteCategoryStart(state, action);
    case actionTypes.CALENDAR_DELETE_CATEGORY_SUCCESS:
      return deleteCategorySuccess(state, action);
    case actionTypes.CALENDAR_DELETE_CATEGORY_FAIL:
      return deleteCategoryFail(state, action);

    case actionTypes.CALENDAR_SAVE_CATEGORY_SETTING_START:
      return saveCategorySettingStart(state, action);
    case actionTypes.CALENDAR_SAVE_CATEGORY_SETTING_SUCCESS:
      return saveCategorySettingSuccess(state, action);
    case actionTypes.CALENDAR_SAVE_CATEGORY_SETTING_FAIL:
      return saveCategorySettingFail(state, action);

    case actionTypes.CALENDAR_DELETE_CATEGORY_SETTING_START:
      return deleteCategorySettingStart(state, action);
    case actionTypes.CALENDAR_DELETE_CATEGORY_SETTING_SUCCESS:
      return deleteCategorySettingSuccess(state, action);
    case actionTypes.CALENDAR_DELETE_CATEGORY_SETTING_FAIL:
      return deleteCategorySettingFail(state, action);

    default:
      return state;
  }
};

export default reducer;
